import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=1ff48ad8&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=1ff48ad8&scoped=true&lang=css&"
import style1 from "./settings.vue?vue&type=style&index=1&id=1ff48ad8&lang=scss&scoped=true&"
import style2 from "./settings.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff48ad8",
  null
  
)

export default component.exports